const SPACE_CODE = 32;

export default function checkOnSpace(event, query) {
    if (event.keyCode === SPACE_CODE && !query) {
        event.preventDefault();
    }
}